import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSubRoutes } from 'hooks';
import { globalPropTypes } from 'helpers';
import {
  loadUserCertificationsCreator,
  loadUserAddListCertificatesCreator,
} from 'store/actionsCreators';
import { connect } from 'react-redux';
import PendingBadges from 'containers/user/PendingBadges/PendingBadges';
import PendingCoupons from 'containers/user/PendingCoupons/PendingCoupons';
import ChangeEmail from './ChangeEmail/ChangeEmail';
import CPDWarning from './CPDWarning/CPDWarning';
import { fetchCpdSumsCreator } from '../../store/actionsCreators';

const User = ({ routes, user, loadUserCertifications, loadAddListCertificates, fetchCpdSums }) => {
  const [renderSubRoutes] = useSubRoutes(routes);

  useEffect(() => {
    loadUserCertifications();
    loadAddListCertificates();
    fetchCpdSums();
  }, [user]);

  return (
    <>
      {renderSubRoutes()}
      <PendingBadges />
      <PendingCoupons />
      {/* <CPDWarning /> */}
      <ChangeEmail email={user.email} />
    </>
  );
};

User.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  loadUserCertifications: PropTypes.func.isRequired,
  loadAddListCertificates: PropTypes.func.isRequired,
  fetchCpdSums: PropTypes.func.isRequired,
};

User.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ user }) => ({ user: user.user });

const mapDispatchToProps = (dispatch) => ({
  loadUserCertifications: () => dispatch(loadUserCertificationsCreator()),
  loadAddListCertificates: () => dispatch(loadUserAddListCertificatesCreator(null, true)),
  fetchCpdSums: () => dispatch(fetchCpdSumsCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(User);
